import type { TablesConfig } from "~/loaders/tabelaDeMedidas"
import type { Product } from "@decocms/apps-commerce/types"

export interface UseTablesProps {
    tables?: TablesConfig[]
    product: Product
}
export function useTabelaDeMedidas({ tables = [], product }: UseTablesProps) {
    const productCategories = new Set(
        product.isVariantOf?.hasVariant.flatMap(({ additionalProperty }) =>
            additionalProperty?.reduce((acc, { name, propertyID }) => {
                if (name === 'category') {
                    acc.push(propertyID as string)
                }
                return acc
            }, [] as string[])
        ),
    )

    const productBrands = new Set(
        product.isVariantOf?.hasVariant.map(({ brand }) => brand?.['@id'] as string),
    )

    const filteredTable = tables.find(({ brand, category }) => {
        if (brand && category) {
            return productBrands.has(brand) && productCategories.has(category)
        }

        if (brand) {
            return productBrands.has(brand)
        }

        if (category) {
            return productCategories.has(category)
        }

        return false
    })

    if (!filteredTable) {
        return
    }

    return filteredTable
}
